export default "__VITE_ASSET__PCt9KUXO__"